import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorage } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private route: Router
  ) { }

  async canActivate(): Promise<boolean> {
    const accessToken = sessionStorage.getItem('access_token')
    
    if (!accessToken) {
      this.route.navigate(['/login']);
      return false;
    }
    return true;
  }
}
